import React from "react"

const Underline = () => {
  return <hr className="mt-2 mb-8 border-orange border-2 w-8 rounded" />
}

export default Underline
